import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../i18n/translations';

const LanguageContext = createContext();

const SUPPORTED_LANGS = ['es', 'en'];

function detectBrowserLang() {
  const nav = navigator.language || navigator.userLanguage || 'es';
  const short = nav.split('-')[0].toLowerCase();
  return SUPPORTED_LANGS.includes(short) ? short : 'es';
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const stored = localStorage.getItem('pulse_lang');
    if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
    return detectBrowserLang();
  });

  useEffect(() => {
    localStorage.setItem('pulse_lang', lang);
  }, [lang]);

  const t = (path) => {
    const keys = path.split('.');
    let val = translations[lang];
    for (const k of keys) {
      val = val?.[k];
    }
    return val || path;
  };

  const toggleLang = () => setLang(l => l === 'es' ? 'en' : 'es');

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t, supportedLangs: SUPPORTED_LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
